var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.isImg
    ? _vm.__get_style([_vm.imgStyle, _vm.$u.addStyle(_vm.customStyle)])
    : null
  var s1 = !_vm.isImg
    ? _vm.__get_style([_vm.iconStyle, _vm.$u.addStyle(_vm.customStyle)])
    : null
  var g0 = _vm.label !== "" ? _vm.$u.addUnit(_vm.labelSize) : null
  var g1 =
    _vm.label !== "" && _vm.labelPos == "right"
      ? _vm.$u.addUnit(_vm.space)
      : null
  var g2 =
    _vm.label !== "" && _vm.labelPos == "bottom"
      ? _vm.$u.addUnit(_vm.space)
      : null
  var g3 =
    _vm.label !== "" && _vm.labelPos == "left"
      ? _vm.$u.addUnit(_vm.space)
      : null
  var g4 =
    _vm.label !== "" && _vm.labelPos == "top" ? _vm.$u.addUnit(_vm.space) : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        s1: s1,
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
        g4: g4,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }